var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topBar"},[_c('div',{staticClass:"topBarContent"},[_vm._v(" De Stip Box "),_c('chevron-right-icon'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$route.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }